var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteHoverButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 132,
    viewBox: "0 0 320 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_551_13195)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 132,
    rx: 20,
    fill: "url(#paint0_linear_551_13195)",
    fillOpacity: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 319,
    height: 131,
    rx: 19.5,
    stroke: "url(#paint1_linear_551_13195)",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_551_13195",
    x1: 0,
    y1: 0,
    x2: 266.368,
    y2: 202.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_551_13195",
    x1: 0,
    y1: 0,
    x2: 266.368,
    y2: 202.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_13195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 132,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteHoverButton);
export default __webpack_public_path__ + "static/media/add_note_hover_button.c75731de71a54c70d4dad242787df9cc.svg";
export { ForwardRef as ReactComponent };